/* Behaviour for snippets/custom-related-products.liquid (tabs + recently viewed). Product handle / currency come from data-* on .custom-featured-collection-wrapper. */
document.addEventListener('DOMContentLoaded', function() {
    const tabBtns = document.querySelectorAll('.custom-tab-btn');
    const recommendedGrid = document.querySelector('.related-products-grid');
    const recentGrid = document.querySelector('.recently-viewed-grid');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        tabBtns.forEach(b => {
          b.style.color = '#c0c0c0ff';
          b.style.fontWeight = 'normal';
          b.classList.remove('active');
        });

        this.style.color = '#000';
        this.style.fontWeight = 'bold';
        this.classList.add('active');

        if (this.getAttribute('data-target') === 'related') {
          if (recommendedGrid) recommendedGrid.style.display = 'grid'; 
          if (recentGrid) recentGrid.style.display = 'none';
        } else {
          if (recommendedGrid) recommendedGrid.style.display = 'none';
          if (recentGrid) recentGrid.style.display = 'block';
        }
      });
    });
  });

document.addEventListener('DOMContentLoaded', function() {
    const relatedRoot = document.querySelector('.custom-featured-collection-wrapper[data-product-handle]');
    const currentHandle = relatedRoot ? relatedRoot.getAttribute('data-product-handle') : '';
    const storeCurrency = relatedRoot ? relatedRoot.getAttribute('data-currency') : ''; // Store currency (e.g., EUR, USD)
    const maxItems = 8; 
    const storageKey = 'theme_recently_viewed';
    
    let recentViewed = JSON.parse(localStorage.getItem(storageKey) || '[]');
    recentViewed = recentViewed.filter(handle => handle !== currentHandle);
    recentViewed.unshift(currentHandle);
    localStorage.setItem(storageKey, JSON.stringify(recentViewed.slice(0, 10)));
    
    const handlesToFetch = recentViewed.filter(handle => handle !== currentHandle).slice(0, maxItems);
    const recentGridContainer = document.querySelector('.recently-viewed-grid');
    const recentTabBtn = document.querySelector('.custom-tab-btn[data-target="recent"]');

    if (handlesToFetch.length >= 2) {
      if (recentTabBtn) {
        recentTabBtn.style.display = 'block'; 
      }

      if (recentGridContainer) {
        recentGridContainer.innerHTML = '';
        
        const gridWrapper = document.createElement('div');
        gridWrapper.className = 'custom-cross-sell-products';
        gridWrapper.style.cssText = 'width: 100%; display: flex; gap: 6px;'; 
        recentGridContainer.appendChild(gridWrapper);

        // Pre-fill the grid with skeletons to prevent the layout from jumping
        let skeletonHtml = '';
        handlesToFetch.forEach(() => {
          skeletonHtml += `
            <div class="custom-cross-sell-product">
              <div class="custom-cross-sell-image vintage-loader-wrapper" style="position: relative; width: 100%; padding-top: 135%; overflow: hidden;"></div>
            </div>
          `;
        });
        gridWrapper.innerHTML = skeletonHtml;

        Promise.all(handlesToFetch.map(handle => 
          fetch(`/products/${handle}.js`).then(res => res.json())
        ))
        .then(products => {
          let html = '';
          
          products.forEach(item => {
            let imgUrl = item.featured_image || (item.media && item.media.length > 0 ? item.media[0].src : '');
            if (imgUrl) {
              const extMatch = imgUrl.match(/\.(jpg|jpeg|png|gif|webp)/i);
              if (extMatch) {
                imgUrl = imgUrl.replace(extMatch[0], `_800x${extMatch[0]}`);
              }
            }

            // Format currency natively, but explicitly swap € symbol for "EUR " at the front
            const formatter = new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: storeCurrency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            });

            let priceStr = item.price ? formatter.format(item.price / 100) : "";
            let comparePriceStr = item.compare_at_price ? formatter.format(item.compare_at_price / 100) : "";

            if (storeCurrency === 'EUR') {
              priceStr = 'EUR ' + priceStr.replace('€', '').trim();
              comparePriceStr = 'EUR ' + comparePriceStr.replace('€', '').trim();
            }
            
            const isSale = item.compare_at_price > item.price;
            
            const hasVariants = item.variants && item.variants.length > 1;
            const soldOut = !item.available;
            const firstVariantId = item.variants && item.variants.length > 0 ? item.variants[0].id : '';

            let buttonHtml = '';
            if (hasVariants) {
              buttonHtml = `
                <button type="button" class="add-to-cart-button product-grid-item-add-to-cart-button js-quick-add-btn" 
                        data-product-handle="${item.handle}" 
                        data-product-id="${item.id}" 
                        ${soldOut ? 'disabled' : ''} 
                        style="padding: 0 0 0 10px; font-size:12px; background: none; border: none; ${soldOut ? 'cursor: not-allowed; opacity: 0.2;' : 'cursor: pointer;'}">
                  +
                </button>
              `;
            } else {
              buttonHtml = `
                <form class="product-form custom-cross-sell-add-to-cart" action="/cart/add" method="post" style="margin: 0; display: inline-flex;">
                  <input type="hidden" name="id" value="${firstVariantId}">
                  <button type="submit" class="add-to-cart-button product-grid-item-add-to-cart-button" 
                          ${soldOut ? 'disabled' : ''} 
                          style="padding: 0 0 0 10px; font-size:12px; background: none; border: none; ${soldOut ? 'cursor: not-allowed; opacity: 0.2;' : 'cursor: pointer;'}" 
                          onclick="event.stopPropagation();">
                    +
                  </button>
                </form>
              `;
            }

            let priceHtml = isSale 
              ? `<span class="compare-at" style="text-decoration: line-through; margin-right: 4px;">${comparePriceStr}</span><span class="sale-price">${priceStr}</span>`
              : `${priceStr}`;

            html += `
              <a class="custom-cross-sell-product" href="${item.url}">
                <div class="custom-cross-sell-image vintage-loader-wrapper" style="position: relative; width: 100%; padding-top: 135%; overflow: hidden;">
                  <img src="${imgUrl}" alt="${item.title}" class="product-image-custom-cross-sell product-image-custom-cross-sell-hover" 
                       style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; display: block; z-index: 4; opacity: 0; transition: opacity 0.6s ease;" 
                       loading="lazy" onload="this.style.opacity=1; this.parentElement.classList.remove('vintage-loader-wrapper');" onerror="this.parentElement.classList.remove('vintage-loader-wrapper');">
                </div>
                
                <div class="custom-cross-sell-info">
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px;">
                    <p class="product__grid__title" style="margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; font-size: 13px;">
                      ${item.title}
                    </p>
                    ${buttonHtml}
                  </div>
                  <p class="product__grid__title" style="margin-top: 2px; font-size: 13px;">
                    ${priceHtml}
                  </p>
                </div>
              </a>
            `;
          });
          
          gridWrapper.innerHTML = html;
        })
        .catch(error => console.error('Error loading recently viewed products:', error));
      }
    }
  });
